import { PaginationType } from 'common';
import { CommunitiesActionType } from 'enums';
import { CommunityType } from 'state';

export const setCommunities = (communities: CommunityType[]) =>
  ({ type: CommunitiesActionType.SET_COMMUNITIES, communities } as const);

export const setCommunitiesAfterScroll = (communities: CommunityType[]) =>
  ({ type: CommunitiesActionType.SET_COMMUNITIES_AFTER_SCROLL, communities } as const);

export const searchCommunities = (search: string) =>
  ({ type: CommunitiesActionType.SEARCH_COMMUNITIES, search } as const);

export const setCommunitiesPagination = (pagination: PaginationType) =>
  ({ type: CommunitiesActionType.SET_COMMUNITIES_PAGINATION, pagination } as const);

export const setCommunitiesLoadingStatus = (isLoading: boolean) =>
  ({ type: CommunitiesActionType.SET_COMMUNITIES_LOADING_STATUS, isLoading } as const);

export const setCertainCommunity = (community: CommunityType) =>
  ({ type: CommunitiesActionType.SET_CERTAIN_COMMUNITY, community } as const);
